<template>

    <images
        :images-uri="route('api.v1.images.index')"
    ></images>

</template>

<script>

    import Images from "../../components/Images/Images";

    export default {

        components:{
            Images,
        },

        metaInfo: {
            title:'Images',
        },

        name:'ImagesIndex',

    }

</script>
